import { render, staticRenderFns } from "./SensorDetailRvs.vue?vue&type=template&id=77f5f87e&scoped=true"
import script from "./SensorDetailRvs.vue?vue&type=script&lang=ts"
export * from "./SensorDetailRvs.vue?vue&type=script&lang=ts"
import style0 from "./SensorDetailRvs.vue?vue&type=style&index=0&id=77f5f87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5f87e",
  null
  
)

export default component.exports